const META_PIXEL_ID = '781262354987892'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return

  // Initialize fbq
  const w = window as any
  if (w.fbq) return

  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Init and track PageView
  w.fbq('init', META_PIXEL_ID)
  w.fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  initialized = true
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', eventName, params)
  }
}
